import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const circles = document.querySelectorAll(".circle-svg circle");
  const circleWrappers = document.querySelectorAll(".circle-wrapper");
  let activeIndex = 0; // First circle active by default

  // Animate circles on scroll
  gsap.utils.toArray(circles).forEach((circle, i) => {
    gsap.to(circle, {
      strokeDashoffset: 0,
      duration: 1.5,
      delay: i * 0.3,
      ease: "power2.out",
      scrollTrigger: {
        trigger: ".four-circles",
        start: "top 80%",
        toggleActions: "play none none none",
      }
    });
  });

  // Show first content by default
  const firstContent = document.querySelector('[data-content-index="0"]');
  const firstWrapper = document.querySelector('[data-circle-index="0"]');
  
  if (firstContent) {
    firstContent.style.display = 'block';
    gsap.fromTo(firstContent, 
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out' }
    );
  }
  
  if (firstWrapper) {
    firstWrapper.classList.add('active');
  }

  // Handle circle clicks
  circleWrappers.forEach((wrapper) => {
    wrapper.style.cursor = 'pointer';
    
    wrapper.addEventListener('click', () => {
      const clickedIndex = parseInt(wrapper.getAttribute('data-circle-index'));
      const contentElement = document.querySelector(`[data-content-index="${clickedIndex}"]`);
      
      if (!contentElement) return;

      // If clicking the same circle, do nothing
      if (activeIndex === clickedIndex) {
        return;
      }

      // Hide previously active content
      const prevContent = document.querySelector(`[data-content-index="${activeIndex}"]`);
      const prevWrapper = document.querySelector(`[data-circle-index="${activeIndex}"]`);
      
      if (prevContent) {
        gsap.to(prevContent, {
          opacity: 0,
          y: 20,
          duration: 0.3,
          ease: 'power2.inOut',
          onComplete: () => {
            prevContent.style.display = 'none';
          }
        });
      }
      
      if (prevWrapper) {
        prevWrapper.classList.remove('active');
      }

      // Show new content with animation
      contentElement.style.display = 'block';
      gsap.fromTo(contentElement, 
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          ease: 'power2.out'
        }
      );
      
      wrapper.classList.add('active');
      activeIndex = clickedIndex;
    });
  });
});
